import { DOWNLOAD_CFG_KEY } from '@intelligence/v3/constants';
import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import { MAX_ROWS_LIMIT, getFileNameCommon } from '@intelligence/components/DownloadCommon/DownloadPage/utils';
import { shouldUseSSE } from '@intelligence/components/DownloadCommon/DownloadPage/utils/sse';

const getDownloadApiParams = <T extends IGenreMarketProfileFetchParams & IRecord = any>(params: T): T => {
  if (!params) return {} as unknown as T;

  const { dateRange = [] } = params || {};
  const [startDate, endDate] = dateRange;

  const apiParams = {
    start_date: startDate,
    end_date: endDate,
    markets: ['global'],
    granularity: 'daily',
    metrics: ['game_count'],
    order_by: ['game_id asc', 'date asc'],
    group_by: ['game_id', 'date', 'minigame_type'],
    minigame_types: [params.order_source || ''],
    page: 1,
    page_size: 10000,
    filter: {
      minigame_genre: [],
    },
    use_sse_page: {
      max_size: MAX_ROWS_LIMIT,
    },
  } as any;

  if (params?.[DOWNLOAD_CFG_KEY.DATA_METHOD] === 'checkedLines') {
    apiParams.app_ids = params.app_ids || [];
  }
  if (params?.[DOWNLOAD_CFG_KEY.DATA_METHOD] === 'selectTop') {
    apiParams.top = {
      group_by: ['game_id', 'minigame_type'],
      order_by: ['game_rank asc'],
      size: params.select_top,
      type: params.select_top_type || 'time',
    };
  }

  // if (params?.[DOWNLOAD_CFG_KEY.DATA_METHOD] === 'selectAll') {
  //   delete apiParams.top;
  // }

  // "top": {
  //   "group_by": ["super_genre"],
  //     "order_by": ["sensortower__revenue desc"],
  //       "size": 1
  // }
  delete apiParams.data_method;
  return apiParams;
};

export default (params: any) => {
  const apiParams = getDownloadApiParams(params);
  // 检查是否启用 SSE 模式
  const useSSE = shouldUseSSE(apiParams);

  return {
    ...commonSetting,
    downloadMode: 'commonConf',
    downloadConfigKey: 'weixinStoreRankMore',
    downloadFetchApi: '/api/v1/intelligence_pc/game/genre_profile/metrics',
    downloadApiParams: apiParams,
    isUsingNewMethod: false,
    // SSE 模式下不需要 fetchOnlyOnce，因为数据是流式传输的
    fetchOnlyOnce: !useSSE,
    dataKey: undefined,
    $$fileName: getFileNameCommon(params),
    regionOptions: params?.regionOptions,
  };
};
